import React from 'react';
import {
    Row,
    Col,
    // DatePicker,
    Typography,
    Skeleton,
    Result,
    Table,
    Card,
    // DatePicker
} from 'antd'
// import {
//   SearchOutlined
// } from '@ant-design/icons';
import {
    useLocation,
    // useNavigate,
} from 'react-router-dom';
import dayjs from 'dayjs';
import { useQuery } from '@tanstack/react-query';

const columns = [
    {
        title: 'Student',
        dataIndex: 'order',
        key: 'order',
        render: (text, _) => `${text.student.fname_th} ${text.student.lname_th}`
    },
    {
        title: 'Course',
        dataIndex: 'product',
        key: 'product',
        render: (text, _) => text.name
    },
    {
        title: 'Begin Date',
        dataIndex: 'start_date',
        key: 'start_date',
        render: (text, _) => dayjs(text).format('DD-MMM-YYYY')
    },
    {
        title: 'End Date',
        dataIndex: 'end_date',
        key: 'end_date',
        render: (text, _) => dayjs(text).format('DD-MMM-YYYY')
    },
]
function DashboardInfo() {

    // const redirect = useNavigate();
    const location = useLocation();
    const start_date = new URLSearchParams(location.search).get('start_date');
    const end_date = new URLSearchParams(location.search).get('end_date');

    const { isError, isLoading, data, error } = useQuery({
        queryKey: [`/api/dashboard/getExpireStudentCourse?start_date=${start_date}&end_date=${end_date}`],
    })

    if (isLoading) {
        return <Skeleton active />
    }

    if (isError) {
        return <Result status="error" title={error.message} />
    };
    // const onSelectDate = (value, dateString) => {
    //     // console.log('Selected Time: ', value);
    //     // console.log('Formatted Selected Time: ', console.log(dayjs(dateString)));
    //     redirect(`/admin/dashboard?start_date=${dayjs(value[0]).toISOString()}&end_date=${dayjs(value[1]).toISOString()}`)
    // };


    // console.log('data = ', data)
    return (
        <div className='dasboardcard-container'>
            <Row justify='space-between'>
                <Col>
                    <Typography.Title
                        level={5}
                        style={{ margin: 0, padding: 0, color: '#483D8B' }}
                    >
                        Courses and Students Infomation
                    </Typography.Title>
                </Col>
                {/* <Col>
                    <DatePicker.RangePicker
                        allowClear={false}
                        defaultValue={[dayjs(start_date), dayjs(end_date)]}
                        onChange={onSelectDate}
                        style={{ width: '100%', borderColor: '#FFF' }} />
                </Col> */}
            </Row>
            <Card
                bordered={false}
                bodyStyle={{
                    background: '#f7f7f7',
                    // border: '1px solid #f2f2f2',
                    // borderRadius: "8px",
                    // minHeight: '350px'
                }}
            >
                <Table
                    bordered={false}
                    rowKey={(record) => record._id}
                    columns={columns}
                    dataSource={data}
                />
            </Card>
        </div>
    )
}

export default DashboardInfo